module.exports = __webpack_public_path__ + "static/media/pilotly_logo_cerulean.db304a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/pilotly_logo_cerulean.png
// module id = 517
// module chunks = 0